// app/components/TelegramLoader.tsx  (или в shared/components/)

'use client'

import Script from 'next/script'
import { useEffect } from 'react'

export default function TelegramLoader() {
  useEffect(() => {
    if (window.Telegram?.WebApp) {
      console.log('Telegram.WebApp уже существует после загрузки')
    }
  }, [])

  const handleLoad = () => {
    console.log('Telegram script loaded!')
    console.log('Telegram.WebApp now exists?', !!window.Telegram?.WebApp)


    const tg = window.Telegram?.WebApp
    if (tg) {
      tg.ready()
      tg.expand()
    }
  }

  return (
    <Script
      src="https://telegram.org/js/telegram-web-app.js"
      strategy="beforeInteractive"
      onLoad={handleLoad}
    />
  )
}